import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Toolbar, Typography, Grid, Paper, Button, Link } from '@material-ui/core';

import logo from "../../assets/linet_logo_color_rgb.svg";
import background from "../../assets/pegasus-header-background.jpg";
import shim from "../../assets/1x1.gif";
import moment from 'moment';

const useStyles = makeStyles((theme) => (
    {
        image: {
            height: "6.5rem",
            width: "24rem",
            marginTop: "1rem",
            marginBottom: "1rem"
        },
        appbar: {
            background: "white",
            // backgroundImage: `url(${background})`,
        },
        welcomeBar: {
            background: theme.palette.primary.light,
        },
        welcomeBarLogo: {
            backgroundImage: `url(${logo})`,
            backgroundSize: 'auto 100%',
            backgroundRepeat: 'no-repeat',
            height: '100px',
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-start',
					alignItems: 'center',
					flexFlow: 'row',
        },
        welcomeBarTop: {
            borderBottom: '3px solid #D0D0CF',
            minHeight: '60px',
            flexFlow: 'row',
        },
        welcomeTime: {
            width: "100%",
            margin: "0",
            color: '#63666a',
            display: 'flex',
            alignItems: 'center',
            height: '100%',
            fontSize: '1.25rem',
            fontWeight: '400',
            lineHeight: '1.6',
					letterSpacing: '0.0075em',
					marginLeft: '220px',
						
        },
        welcomePhoneNumber: {
            width: "100%",
            margin: "0 auto",
						color: '#63666a',
            paddingRight: '5pt',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            height: '100%',
            fontSize: '1.25rem',
            fontWeight: '700',
            lineHeight: '1.6',
            letterSpacing: '0.0075em',
        },
        welcomeBarNavigation: {
            justifyContent: 'space-around',
            alignItems: 'center',
            height: '100px',	
            width: '100%',
            paddingLeft: '190px',
            paddingRight: '10%',
        },
        welcomBarNavigationItem: {
						color: '#63666a',
            textDecoration: 'none',
            textTransform: 'uppercase',
            fontSize: '14pt',
        },
        loginButtonTop: {
            height: '100%',
            width: '100%',
            margin: "0 auto",
            fontSize: '12pt',
            textTransform: 'uppercase',
		},
		logoShim: {
			width: '230px',
		},
				logoDivider: {
					backgroundColor: '#D0D0CF',
					width: '3px',
					height: '50px',
					marginRight: '30px',
					marginLeft: '30px',
					
		},
		portalName: {
			color: '#63666a',
			fontFamily: 'GT-America-Expanded',
			textTransform: 'uppercase',
			fontSize: '34pt',	
		},
		timeText: {
			whiteSpace: 'nowrap',
		},
		maintenanceBanner: {
			color: '#e10600',
			fontFamily: 'GT-America-Expanded',
			fontSize: '9pt',	
			border: '1px solid #e10600',
			padding: '2px',
			marginLeft: '10px',
		},
    }
));



const Header = () => {
    const classes = useStyles();
    return (
        <AppBar
            elevation={0}
            className={classes.appbar}
            position="static"
        >
            <Grid
                item
                xs={12}
            >
                    <Grid
                        container
                        className={classes.welcomeBarTop}
                    >
                        <Grid
                            item
                            xs={8}
                        >
                            <Paper
                                elevation={0}
                                square
                                className={classes.welcomeTime}
                        >
                            {/*Sydney: Tue 7 September, 2021 | 03:12 PM*/}
								<div className={classes.timeText}>{moment().format('LLLL')}</div>
								
                            </Paper>
						</Grid>
						<Grid
							item
							xs={2}
						></Grid>
                        <Grid
                            item
                            xs={2}
                    >
                            <Link
                                href='#login'>
                                <Button
                                type="submit"
                                color="primary"
                                variant="contained"
                                className={classes.loginButtonTop}
                                >
                                    LOGIN
                                </Button>
                            </Link>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        className={classes.welcomeBarNavigation}
                    >
                        <Grid
														item
														className={classes.welcomeBarLogo}
                        >
							<Grid className={classes.logoShim }></Grid>
											<Grid item className={classes.logoDivider}>
												<img src={shim} />
											</Grid>
																		<Grid item className={classes.portalName }>
																				Rental Portal
													</Grid>
												</Grid>
                    </Grid>
                </Grid>
        </AppBar>
    )
}

export default Header;